// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"f3c4cf3a","977":"6a7f6471"}[chunkId] + ".chunk.js";
};